import { render } from "./ProjectIndexFilters.vue?vue&type=template&id=655d06d1"
import script from "./ProjectIndexFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectIndexFilters.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Admin/Project/ProjectIndexFilters.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "655d06d1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('655d06d1', __exports__)) {
    api.reload('655d06d1', __exports__)
  }
  
  module.hot.accept("./ProjectIndexFilters.vue?vue&type=template&id=655d06d1", () => {
    api.rerender('655d06d1', render)
  })

}


export default __exports__